import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { StorageService } from '@services/core/storage.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

    const authService = inject(MicrosoftAuthService)
    const storageService = inject(StorageService)
    const token = authService.token();

    if (!token) {
        return next(req);
    }

    const cloned = req.clone({
        setHeaders: {
            Authorization: `${token}`
        }
    });

    return next(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                storageService.clearStorage()
                window.location.href = '/'
            }
            return throwError(() => error)
        })
    );
};